import React from "react";
import {phaseColSpan} from "./analyticsUtils";

export default function ({reportAnalytics, phase, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      <th data-align="center" key={phase.guid} colSpan={phaseColSpan(reportAnalytics, phase, enablePtoAnalytics)}>{phase.header}</th>
      {!enablePtoAnalytics && <th>#</th>}
    </tr>
  )
}
